
<div *ngIf="allowLocalizationChange">
    <kendo-dropdownlist
      [data]="availableLocalizations"
      textField="text"
      valueField="value"
      [value]="selectedValue"
      [valuePrimitive]="true"
      fillMode="flat"
      class="loc-select"
      (valueChange)="onChange($event)"
      adaptiveMode="auto"
      >
    
    <ng-template kendoDropDownListItemTemplate let-dataItem>
        <img [src]="dataItem.flag" [width]="24"
        [title]="dataItem.value" />
        <!-- <span class="small-info">{{ dataItem.text }}</span>  -->
      </ng-template>

      <ng-template kendoDropDownListValueTemplate let-dataItem>
        <img [src]="dataItem.flag" [width]="24"
        [title]="dataItem.value" />
      </ng-template>

    </kendo-dropdownlist>
  </div>